(function () {
  'use strict';

  if (window.__foHomeInit) return;
  window.__foHomeInit = true;

  var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* --- Reveal on scroll delle sezioni nuove -------------------------- */

  function initReveal() {
    var nodes = document.querySelectorAll('.fo-reveal');
    if (!nodes.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, function (node) {
        node.classList.add('is-in');
      });
      return;
    }

    document.documentElement.classList.add('fo-reveal-ready');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      /* vedi fo-editorial.js: sul telefono l'innesco anticipa il bordo inferiore,
         altrimenti si scorre dentro sezioni ancora vuote */
      window.matchMedia('(max-width: 767px)').matches
        ? { rootMargin: '0px 0px 12% 0px', threshold: 0 }
        : { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
    );

    Array.prototype.forEach.call(nodes, function (node) {
      io.observe(node);
    });
  }

  /* --- Video: play solo quando è in vista, pausa quando esce --------- */

  function initVideos() {
    var videos = document.querySelectorAll('video[data-fo-autoplay]');
    if (!videos.length) return;

    function play(video) {
      if (video.dataset.foLoaded !== '1') {
        video.dataset.foLoaded = '1';
        video.load();
      }
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(videos, play);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            play(video);
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px', threshold: 0.15 }
    );

    Array.prototype.forEach.call(videos, function (video) {
      io.observe(video);
    });
  }

  /* --- Pulsante audio ------------------------------------------------ */

  function initSound() {
    document.querySelectorAll('[data-fo-video-sound]').forEach(function (btn) {
      var frame = btn.closest('[data-fo-video-frame]');
      var video = frame && frame.querySelector('video[data-fo-video-el]');
      if (!video) return;

      btn.addEventListener('click', function () {
        video.muted = !video.muted;
        var on = !video.muted;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.classList.toggle('is-on', on);
        if (on) {
          video.removeAttribute('aria-hidden');
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      });
    });
  }

  /* --- YouTube / Vimeo: iframe caricato solo al click ---------------- */

  function initEmbeds() {
    document.querySelectorAll('[data-fo-video-embed]').forEach(function (holder) {
      var btn = holder.querySelector('[data-fo-video-play]');
      if (!btn) return;

      function load() {
        var type = holder.getAttribute('data-embed-type');
        var id = holder.getAttribute('data-embed-id');
        if (!id) return;

        var src =
          type === 'vimeo'
            ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&title=0&byline=0&portrait=0'
            : 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';

        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', src);
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', document.title);
        holder.appendChild(iframe);
        holder.classList.add('is-playing');
        btn.remove();
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        load();
      });
    });
  }

  ready(function () {
    initReveal();
    initVideos();
    initSound();
    initEmbeds();
  });
})();
